<template>
  <div id="dashboards">
    <v-container v-show="!loadingPage" fluid>
      <div :class="`event-container`" ref="dashboardRef"></div>
    </v-container>
    <v-container v-if="loadingPage" fill-height fluid class="load-parent">
      <v-progress-circular
        indeterminate
        color="primary"
        class="loader"
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import { dashboard } from "../lib/analysis";
import { createEmbeddingContext } from "amazon-quicksight-embedding-sdk";

export default {
  name: "Dashboards",
  components: {},
  data() {
    return {
      loadingPage: true,
      dashboard: [],
      embeddingContext: null,
      embeddedDashboard: null
    };
  },
  methods: {
    async refresh() {
      try {
        this.loadingPage = true;

        this.dashboard = await dashboard();
        const embeddingContext = await createEmbeddingContext();

        const options = {
          url: this.dashboard.url,
          container: this.$refs.dashboardRef,
          height: "95%",
          width: "100%"
        };

        this.embeddedDashboard = await embeddingContext.embedDashboard(options);
      } catch (err) {
        this.showError(`Unable to read dashboards - ${err.message}`);
      }

      this.loadingPage = false;
    }
  },
  async mounted() {
    this.refresh();
  }
};
</script>

<style lang="scss">
#dashboards {
  .load-parent {
    min-height: 300px;
    width: 100%;

    .loader {
      margin: auto;
    }
  }

  .container {
    padding-bottom: 0px;
  }

  .v-slide-group__content {
    left: 50px;
  }

  .paging {
    text-align: center;
  }
}

.event-container {
  height: calc(100vh - 200px);
  overflow: auto;
}
</style>
